<div class="npdc-title">
  <h1>Plankton import batches</h1>
</div>

<p>
  This is the import metadata associated with the
  <a routerLink="/dataset/{{ planktonDatasetId }}"> Marine plankton biodiversity </a>
  dataset.
</p>

<app-list [resource]="response">
  @if (!response.error()) {
    <mat-nav-list>
      @for (origin of response.value()?.items; track origin.id) {
        <a mat-list-item routerLink="/plankton/origin/{{ origin.id }}">
          <mat-icon matListItemIcon>{{ origin | originIcon }}</mat-icon>
          <span matListItemTitle>{{ origin | originTitle }}</span>
          <span matListItemLine>{{ origin | originAbstract }}</span>
        </a>
      }
    </mat-nav-list>

    <mat-paginator
      showFirstLastButtons
      (page)="onPageEvent($event)"
      [length]="response.value()?.count"
      [pageIndex]="page()"
      [pageSize]="pageSize()"
      [pageSizeOptions]="[10, 20, 50, 100]"
    >
    </mat-paginator>
  }
</app-list>
